import { configureStore } from "@reduxjs/toolkit";
import gitStatusReducer from "./gitStatusSlice";
import iframeReducer from "./iframeSlice";
import codebaseSlice from "./codebaseSlice";
import globalSettingsSlice from "./globalSettingsSlice";
import metadataSlice from "./metadataSlice";
import supabaseSlice from "./supabaseSlice";
import projectsSlice from "./projectsSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const store = configureStore({
  reducer: {
    gitStatus: gitStatusReducer,
    iframe: iframeReducer,
    codebase: codebaseSlice,
    globalSettings: globalSettingsSlice,
    metadata: metadataSlice,
    supabaseStore: supabaseSlice,
    projects: projectsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
